import _reduxForm from "redux-form/es/reduxForm";
import { connect } from 'react-redux';
import { RESELLER_FORM } from '../../../../../../redux/redux.constants';
import { formSelector } from '../../../../../../redux/landings/landings.selectors';
import { resellerFormDispatcher } from '../../../../../../redux/landings/landings.dispatchers';
import { ReadyToFindFormComponent } from './ready-to-find-form';
const reduxFormHoc = _reduxForm({
  form: RESELLER_FORM
});
const connectHoc = connect(formSelector, resellerFormDispatcher);
export const ReadyToFindForm = connectHoc(reduxFormHoc(ReadyToFindFormComponent));